import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from '../../../../../environments/environment.prod';
import { NgForm } from '@angular/forms';
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { UserService } from '../UserDetails/user.service';
import { UserProfile } from '../UserDetails/user.profile';
import { IProfile } from '../UserDetails/user.model';
import { Notification } from '../../../../core/Notifications/Notification';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { OtpComponent } from '../otp/otp.component';
import { MatDialog } from '@angular/material/dialog';
import { OtpboxComponent } from '../otpbox/otpbox.component';
@Component({
  selector: 'app-forgot',
  templateUrl: './forgotpassword.html',
  styleUrls: ['./forgotpassword.component.scss']
})
export class forgotpasswordComponent implements OnInit {
  forgotdetails: forgot;
   loginform: FormGroup;
  id: any;
  constructor(private fb: FormBuilder,
    private modalService: NgbModal,
    private authProfile: UserProfile,
    private router: Router, private route: ActivatedRoute,
    private userservice: UserService, private Http: HttpClient, private notify: Notification,public dialog: MatDialog,) {
    this.forgotdetails = <forgot>{};
    this.loginform = this.fb.group({
      'phoneNumber': ['', [Validators.pattern("[0-9]{10}$")]]
    })
    
  }

  ngOnInit(): void {

  }
  SendOTP(){
    this.Http.get(`${environment.Login_URL}` + `api/Authentication/SendOTP_ForgotPwd/${this.loginform.value.phoneNumber}/${'1407167957139097720'}`).subscribe((data: any) => {
      console.log('Data', data);
      this.id = data.Id;
      if (data.IsSuccess) {
        let Data = {
          "phoneNumber": this.loginform.value.phoneNumber,
          "id": this.id,
          "otp": ""
        };
        const dialogRef = this.dialog.open(OtpComponent,
        //    {
        //   data: Data,
        //   disableClose: true
        // });
        {
          height: '100%',
          width: '100%',
          maxWidth: '100%',
          data: Data,
          disableClose: true
        });
      }
      else  {
        this.notify.errorsmsg(data.Message);
         window.location.reload();
        
      }

    })
    // window.location.reload();
    //     this.router.navigateByUrl['/auth/otp']
  }


}
export interface forgot {
  userid: string;
  changepassword: string;
  confirmpassword: string;
}